export default __webpack_public_path__ + "static/media/expl-gradcam_02_EN.778691c5.png";